var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('title-text'),_c('summary-content'),_c('content-text'),_c('blog-category-active-card')],1),_c('seo-component',{attrs:{"data-store":"blogCategories/dataItem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }